/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Fragment } from 'react';

import { Typography, useTheme } from '@coursera/cds-core';
import { ErrorFilledIcon, SpinnerIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/program-skills-objectives';

type Props = {
  dataState: 'error' | 'loading';
};

const LevelSetsResultDataState = ({ dataState }: Props) => {
  const theme = useTheme();
  return (
    <div
      css={{
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(32),
      }}
    >
      {dataState === 'error' && (
        <Fragment>
          <ErrorFilledIcon size="large" color="default" />
          <Typography component="h2" variant="h2">
            {_t('There was an issue loading your results. Please try refreshing the page.')}
          </Typography>
        </Fragment>
      )}

      {dataState === 'loading' && (
        <Fragment>
          <SpinnerIcon
            css={css`
              animation: spinAnimatin 3s infinite linear;

              @keyframes spinAnimatin {
                0% {
                  -webkit-transform: rotate(0deg);
                  transform: rotate(0deg);
                }

                100% {
                  -webkit-transform: rotate(360deg);
                  transform: rotate(360deg);
                }
              }
            `}
            size="large"
            color="default"
          />
          <Typography component="h2" variant="h2">
            {_t('Please wait while we calculate your results.')}
          </Typography>
        </Fragment>
      )}
    </div>
  );
};

export default LevelSetsResultDataState;
